import { schema } from "normalizr";

const company = new schema.Entity(`companies`);
const arrayOfCompanies = [company];

export { company, arrayOfCompanies };
